// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

// 引入ui框架
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 移动端判断脚本
import IsPC from './assets/js/platform'
import Adapt from './assets/js/HD_adapt'

Vue.use(ElementUI)

Vue.config.productionTip = false

function initMB (name) {
  let ruReg = /^m/;

  if (IsPC()) {
    if (ruReg.test(name)) {
      try {
        this.$router.replace({name: 'Home'});
      } catch (e) {
        window.location.href = '/';
      }
    }
    return false;
  }

  if (!ruReg.test(name)) {
    this.$router.replace({name: 'm' + name});
  }
  Adapt.init();
  document.getElementsByTagName('html')[0].classList.add('mobile');
  try {
    setTimeout(function () {
      document.getElementById('scroller').style.height = window.px2rem(document.body.clientHeight) - 0.88 + 'rem';
    }, 10);
    document.getElementById('scroller').scrollTop = 0;
  } catch (e) {
    console.log(e);
  }
}

/* eslint-disable no-new */
const APP = new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>',
  created () {
    initMB.call(this, this.$route.name);
  }
})

APP.$router.beforeEach((to, from, next) => {
  // 路由匹配不到直接去404错误页
  if (to.matched.length < 1) {
    APP.$router.push('/');
    return false;
  }

  initMB.call(APP, to.name);
  next();
});



// WEBPACK FOOTER //
// ./src/main.js